import { RecommendationMetadata, RecommendationType } from "src/types.js";

export function largeNumberFormatter(value: number | string) {
	const intValue = typeof value === "string" ? parseInt(value, 10) : value;

	const formatter = new Intl.NumberFormat("nb", {
		maximumFractionDigits: 0,
	});

	return formatter.format(intValue);
}

export function transmissionStringResolver(value: string) {
	switch (value) {
		case "AUTOMATIC":
		case "Automat":
			return "Automat";

		case "Manuell":
			return "Manuell";

		default:
			return "";
	}
}

export function buildSrText(type: RecommendationType, title: string, metadata: RecommendationMetadata) {
	const mileage = largeNumberFormatter(metadata.mileage ?? "");

	switch (type) {
		case "CAR":
		case "MOBILE_HOME":
			if (!metadata.mileage) {
				return `${title}. ${metadata.year}.`;
			}

			return `${title}. ${metadata.year}. ${mileage} km.`;
		case "CARAVAN":
			return `${title}. ${metadata.year}. ${metadata.numberOfBeds} senger`;
	}
}

export function buildMetadataString(type: RecommendationType, metadata: RecommendationMetadata) {
	if (Object.keys(metadata).length === 0) {
		return "";
	}

	const mileage = metadata.mileage ? largeNumberFormatter(metadata.mileage) : "";
	const transmission = transmissionStringResolver(metadata.transmission ?? "");

	switch (type) {
		case "CAR":
		case "MOBILE_HOME":
			return [metadata.year, mileage ? `${mileage} km` : "", transmission].filter((v) => !!v).join(" / ");

		case "CARAVAN":
			return [metadata.year, metadata.numberOfBeds ? `${metadata.numberOfBeds} senger` : ""]
				.filter((v) => !!v)
				.join(" / ");
	}
}
